module.exports = __webpack_public_path__ + "static/media/background.5d9e6c01.jpg";